<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">BBA Entrance Exam</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">BBA Entrance Exam</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="ptb--100 ">
  <div class="container">
    <div class="row justify-content-center gx-4 gy-3">
      <div class="col-md-12">
        <h4>
          BBA Entrance Exam 13 th June 2022, 10am
        </h4>
        <blockquote class="blockquote-div">
          <p><a class="text-black"
              href="https://docs.google.com/forms/d/e/1FAIpQLSfu5I0cEXnq8aCiR40z5A8WXTncTvbymZ7LKBEk4lCjJ9X5kw/viewform?usp=sf_link"
              target="_blank">Registartion:
              https://docs.google.com/forms/d/e/1FAIpQLSfu5I0cEXnq8aCiR40z5A8WXTncTvbymZ7LKBEk4lCjJ9X5kw/viewform?usp=sf_link</a>
          </p>
        </blockquote>

        <h5 class="yellow-color mt-3 fw-bold">Eligibility for entrance:</h5>
        <ul class="list-before">
          <li>Candidate must have appeared or passed for 12th /Diploma examination</li>
          <li>He should have achieved 45% and above in 12th/Diploma Examination</li>
        </ul>
        <p>After Registration, eligible students will be called and they can collect admit card from college on or
          before 13th june 2022.
        </p>
      </div>
    </div>
  </div>
</section>
